import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { AuthorizationService } from './authorization.service';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  isRefreshingToken: boolean = false;
  tokenSubject: Subject<boolean> = new Subject<boolean>();
  token: string = '';
  cookieHeaderName = 'X-XSRF-TOKEN';

  constructor(private authorizationService: AuthorizationService) {}

  private static addHeadersToRequest(request, token, headerName) {
    return request.clone({ headers: request.headers.set(headerName, token) });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (this.token !== null && this.token !== '' && !request.headers.has(this.cookieHeaderName)) {
      request = AuthInterceptor.addHeadersToRequest(request, this.token.toString(), this.cookieHeaderName);
    }

    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status !== 401) {
          return throwError(err);
        }
        return this.handleError(request, next);
      })
    );
  }

  handleError(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;
      this.authorizationService.authorizeUser().subscribe(() => {
        this.token = this.authorizationService.getCookie('XSRF-TOKEN').toString();
        this.tokenSubject.next(true);
        this.isRefreshingToken = false;
      });
    }

    return this.tokenSubject.pipe(
      switchMap(() => {
        if (this.token !== null && this.token !== '' && !request.headers.has(this.cookieHeaderName)) {
          request = AuthInterceptor.addHeadersToRequest(request, this.token.toString(), this.cookieHeaderName);
        }
        return next.handle(request);
      })
    );
  }
}
